import httpService from "./httpService";

export default {

   findAttachmentById(id) {
    return httpService.get(`/outgoingDocVersion/findAttachmentById/${id}`);
  },
  findAllByDocId(id){
    return httpService.get(`/outgoingDocVersion/findAllByDocId/${id}`);
  },
  findRelationDocVersion(id){
    return httpService.get(`/outgoingDocVersion/findRelationDocVersion/${id}`);
  },
  revertVersionDoc(id) {
    return httpService.post(`/outgoingDocVersion/revertVersionDoc/${id}`);
  },

  revertVersionDocLanhDaoEdit(id) {
    return httpService.post(`/outgoingDocVersion/revertVersionDocLanhDaoEdit/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/outgoingDocVersionService.js